import {
  Header1,
  Instruction,
  InstructionWithContent,
  InstructionWithImage,
} from "../../BlockComponent";
import {
  ButtonGroup,
  GuideTypographyLine,
  LineWithSolidLabel,
  TypographyLine,
} from "../../CellComponent";
import { LastCard } from "../common";

export const Content_11_2_A = [
  Header1("typography_0"),
  Instruction("typography_1"),
  Instruction("typography_2"),

  Header1("typography_3"),
  Instruction("typography_4"),
  InstructionWithImage("typography_5", "0"),
  Instruction("typography_6"),

  InstructionWithContent(`typography_7`, [
    [
      ButtonGroup(
        [
          { text: "A. 머릿속을 스쳐가는 부정적인 '생각'" },
          { text: "B. 불안하고 초조한 '감정'" },
          { text: "C. 도망치고 싶어지는 '충동'" },
          { text: "D. 실수를 저지른 객관적인 '상황'" },
        ],
        { id: "quiz", vertical: true }
      ),
    ],
    GuideTypographyLine("typography_quiz_incorrect", {
      answerList: [{ id: "quiz", answerIndex: 3 }],
    }),
  ]),

  Instruction("typography_8"),

  Header1("typography_9"),
  InstructionWithImage("typography_10", "1"),
  Instruction("typography_11"),

  InstructionWithContent(`typography_12`, [
    ...LineWithSolidLabel("생각", TypographyLine("typography_bundle_thought")),
    ...LineWithSolidLabel("감정", TypographyLine("typography_bundle_emotion")),
    ...LineWithSolidLabel(
      "신체 반응",
      TypographyLine("typography_bundle_body")
    ),
    ...LineWithSolidLabel(
      "행동/충동",
      TypographyLine("typography_bundle_action")
    ),
  ]),

  Header1("typography_13"),
  Instruction("typography_14"),
  Instruction("typography_15"),
  Instruction("typography_16"),

  ...LastCard,
];
